// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-icon[data-v-f0ac44a8]{position:absolute;right:0;top:0;margin-bottom:10px}.v-card__title[data-v-f0ac44a8]{word-break:normal}.vue-html2pdf[data-v-f0ac44a8]{font-size:2em}", ""]);
// Exports
module.exports = exports;
